import { useCallback, useContext } from 'react';
import { useStore } from 'react-redux';
import NowPlayingContext from '../contexts/NowPlayingContext';
import { selectIsNowPlayingDialogOpen } from '../selectors/dialog';

export default function withNowPlayingContext(MyComponent) {
  const WithNowPlayingContext = (props) => {
    const nowPlayingContext = useContext(NowPlayingContext);
    const store = useStore();
    // A getter rather than a subscription: this wraps every tile on a page, and only their click
    // handlers need to know whether Now Playing is open.
    const getIsNowPlayingOpen = useCallback(
      () => selectIsNowPlayingDialogOpen(store.getState()),
      [store],
    );

    return (
      <MyComponent
        {...props}
        nowPlayingContext={nowPlayingContext}
        getIsNowPlayingOpen={getIsNowPlayingOpen}
      />
    );
  };

  return WithNowPlayingContext;
}
